/** Update Business Address (M32018) 문서 provide/inject 컨텍스트. */
import type { InjectionKey, Ref } from 'vue';
import type { UpdateBusinessAddressFieldType } from './updateBusinessAddressFields';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';

export interface UpdateBusinessAddressDocContext {
  valueOf: (key: string) => string;
  labelOf: (key: string) => string;
  typeOf: (key: string) => UpdateBusinessAddressFieldType;
  activeKey: Ref<string>;
  activate: (key: string) => void;
  setFieldValue: (key: string, val: string) => void;
  openAddress: (key: string) => void;
  entityCd: Ref<string>;
  signersOf: (varKey: string) => SignerEntry[];
  setSigners: (varKey: string, list: SignerEntry[]) => void;
  pendingPickValue: Ref<string>;
  placePick: (key: string) => boolean;

  /** [[if X]] 조건 토글 (records_a~k, change_nature_of_business 포함) */
  flag: (name: string) => boolean;
  toggleFlag: (name: string) => void;
  /** resolution_basis */
  choiceOf: (name: string) => string;
  setChoice: (name: string, val: string) => void;
}

export const UPDATE_BUSINESS_ADDRESS_DOC_CTX: InjectionKey<UpdateBusinessAddressDocContext> = Symbol('updateBusinessAddressDocCtx');
